<template>
	<section class="other_page_banner corban banner_nxt_sec_touch">
		<div class="container">
			<div class="row">
				<div class="col-sm-6 order-2 order-md-1">
					<div class="ban_lt">
						<h5>
							{{ $t('new_ui.business_corps_page.section_banner.title.one') }}
						</h5>
						<h2>
							{{
								$t('new_ui.business_corps_page.section_banner.main_title.one')
							}}
						</h2>
						<p>
							{{
								$t('new_ui.business_corps_page.section_banner.paragraph.one')
							}}
						</p>

						<div
							class="ban_lt_btn d-flex justify-content-start align-items-center p-top"
						></div>
					</div>
				</div>
				<div class="col-sm-6 order-1 order-md-2">
					<div class="ban_rt">
						<img :src="img.image1" alt="Logo" />
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="credit_system wallet_sec">
		<div class="container">
			<div class="row">
				<div class="col-sm-12 border_dash">
					<div class="row">
						<div class="col-sm-6">
							<div class="creditcard_system_inn credit_system_rt">
								<img class="mb-0" :src="img.image2" alt="" />
							</div>
						</div>
						<div class="col-sm-6">
							<div class="creditcard_system_inn credit_system_rt">
								<span>{{
									$t('new_ui.business_corps_page.wallet_sec.label')
								}}</span>
								<div class="creditcard_system_txt">
									<h4>
										{{ $t('new_ui.business_corps_page.wallet_sec.title.one')
										}}<br />
										{{ $t('new_ui.business_corps_page.wallet_sec.title.two') }}
										<span>{{
											$t('new_ui.business_corps_page.wallet_sec.title.three')
										}}</span>
									</h4>
									<p>
										{{
											$t('new_ui.business_corps_page.wallet_sec.paragraph.one')
										}}
									</p>
									<p>
										{{
											$t('new_ui.business_corps_page.wallet_sec.paragraph.two')
										}}
									</p>
									<div class="starting_to_btn">
										<a href="/auth/register">{{
											$t(
												'new_ui.business_corps_page.wallet_sec.cta_buttons.one',
											)
										}}</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="charging_sec corps_dwn">
		<div class="container">
			<div class="row">
				<div
					class="col-sm-12 col-xxl-3 col-xl-3 col-lg-3 col-md-4 d-block d-md-none"
				>
					<div class="charging_rt">
						<img :src="img.image4" alt="" />
					</div>
				</div>
				<div class="col-sm-12 col-xxl-9 col-xl-9 col-lg-9 col-md-8">
					<div class="charging_lt">
						<span>
							{{ $t('new_ui.business_corps_page.corps_dwn.label') }}
						</span>
						<div class="charging_lt_txt">
							<h4>
								{{ $t('new_ui.business_corps_page.corps_dwn.title.one') }}<br />
								<span>{{
									$t('new_ui.business_corps_page.corps_dwn.title.two')
								}}</span>
							</h4>
							<p>
								{{ $t('new_ui.business_corps_page.corps_dwn.paragraph') }}
							</p>

							<div class="starting_to_btn">
								<a href="/auth/register">{{
									$t('new_ui.business_corps_page.corps_dwn.cta_buttons.one')
								}}</a>
							</div>
						</div>
					</div>
				</div>
				<div
					class="col-sm-12 col-xxl-3 col-xl-3 col-lg-3 col-md-4 d-none d-md-flex"
				>
					<div class="charging_rt">
						<img :src="img.image3" alt="" />
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="newsletter_sec">
		<div class="container">
			<div class="row">
				<div class="col-sm-12 col-xxl-5 col-xl-5 col-lg-5 col-md-12">
					<div class="newsletter_lt">
						<span>{{
							$t('new_ui.business_corps_page.section_newsletter.label')
						}}</span>
						<div class="newsletter_txt">
							<h4>
								<span>{{
									$t('new_ui.business_corps_page.section_newsletter.title.one')
								}}</span>
								{{
									$t('new_ui.business_corps_page.section_newsletter.title.two')
								}}
							</h4>
						</div>
					</div>
				</div>
				<div class="col-sm-12 col-xxl-7 col-xl-7 col-lg-7 col-md-12">
					<div class="newsletter_rt">
						<p>
							{{
								$t(
									'new_ui.business_corps_page.section_newsletter.description.one',
								)
							}}
						</p>
						<form>
							<div class="news_mail">
								<div class="news_mail_lt">
									<input
										type="email"
										:placeholder="
											$t(
												'new_ui.business_corps_page.section_newsletter.form.placeholder',
											)
										"
									/>
								</div>
								<div class="news_mail_rt">
									<button type="submit" value="submit">
										{{
											$t(
												'new_ui.business_corps_page.section_newsletter.form.button',
											)
										}}
									</button>
								</div>
							</div>
						</form>
						<p class="mt-3">
							{{
								$t(
									'new_ui.business_corps_page.section_newsletter.description.two',
								)
							}}
						</p>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import corpsban from '@/assets/images/sub/corps_ban.png';
import automatic from '@/assets/images/sub/automatic.png';
import cmob from '@/assets/images/sub/cmob.png';
import corpsmob from '@/assets/images/sub/corps_mob.png';

export default {
	data: () => {
		return {
			img: {
				image1: corpsban,
				image2: automatic,
				image3: cmob,
				image4: corpsmob,
			},
		};
	},
};
</script>
